import { cn } from "@/lib/utils"
import Link from "next/link"

type LogoProps = {
	className?: string
	size?: "sm" | "md" | "lg"
	showText?: boolean
}

export function Logo({ className, size = "md", showText = true }: LogoProps) {
	const sizes = {
		sm: "h-7 w-7",
		md: "h-9 w-9",
		lg: "h-12 w-12",
	}

	const textSizes = {
		sm: "text-base",
		md: "text-lg",
		lg: "text-2xl",
	}

	return (
		<Link href="/" className={cn("flex items-center gap-2.5", className)}>
			<div
				className={cn(
					"rounded-lg bg-zinc-950 border border-zinc-800 flex items-center justify-center",
					sizes[size],
				)}
			>
				<svg
					className={cn(
						"text-primary",
						size === "sm" ? "w-4 h-4" : size === "md" ? "w-5 h-5" : "w-7 h-7",
					)}
					viewBox="0 0 100 100"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					aria-hidden="true"
				>
					<rect
						x="20"
						y="20"
						width="60"
						height="15"
						rx="7.5"
						fill="currentColor"
					/>
					<rect
						x="20"
						y="42.5"
						width="40"
						height="15"
						rx="7.5"
						fill="currentColor"
						opacity="0.8"
					/>
					<rect
						x="40"
						y="65"
						width="40"
						height="15"
						rx="7.5"
						fill="currentColor"
						opacity="0.6"
					/>
				</svg>
			</div>
			{showText && (
				<span className={cn("font-semibold text-foreground", textSizes[size])}>
					Vident
				</span>
			)}
		</Link>
	)
}
